<!--
 * @Author: nihuaifa
 * @Date: 2023-09-15 10:14:44
 * @LastEditors: nihuaifa
 * @LastEditTime: 2024-01-10 15:03:06
 * @Description: 请填写简介
-->
<template>
  <div
    class="review-wrap"
    v-if="postInfo"
    v-track="{
      act: 'show',
      params: { event_id: '081|083|02|077',  sku_id: skuId }
    }"
  >
    <v-list-view
      name="评测"
      :type="2"
      right-text="查看全部"
      right-icon="arrow-right-v3"
      @click="gotoReviewCenter(2)"
    >
      <!-- 评测信息 -->
      <div class="info"  tabindex="0" @click="gotoReviewCenter(3)">
        <swiper ref="mySwiper" :noSwiping="true"  @touchEnd="touchEnd" @touchStart="touchStart" :options="{ freeMode: true, slidesPerView: 'auto', cssMode: true, slidesOffsetAfter: 18 }" aria-label="评测帖子列表">
          <swiper-slide v-for="(item,index) in postInfo" :key="index+Math.random" class="info-item">
            <div  @click.stop="gotoReviewDetail(item.h5LinkUrl,item.sourceId)">
              <div class="img-wrap" :class="{'video-post':item.containsVideo}">
                <img v-lazy="item.videos[0]&&item.videos[0].coverUrl" alt="帖子视频封面" v-if="item.containsVideo" aria-label="帖子视频封面"/>
                <img v-lazy="item.images[0]&&item.images[0].url" alt="帖子封面图" aria-label="帖子封面图" v-else/>
              </div>
              <div class="des">
                <p class="title" :aria-label="item.title ||item.summary">{{ item.title ||item.summary }}</p>
                <div class="user">
                  <img :src="item.author.avatarPath"/>
                  <span class="name" aria-hidden="true">{{ item.author.nickName }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <SlideMore  v-if="showMore" txt="继续滑动查看更多"/>
        </swiper>
      </div>
    </v-list-view>
  </div>
</template>

<script>
import API from '@/api'
import { getCommodityPostList } from '../../index/api'
import SlideMore from '@/components/slide-more'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { common } from '@/utils'

export default {
  name: 'Review',
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId'])
  },
  data() {
    return {
      // 评测信息
      postInfo: null,
      evaluateCenterUrl:'',
      showMore:false,
      sId:''//专题id
    }
  },
  components: {
    SlideMore,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide,
  },
  created() {
    this._getCommodityPostList()
  },
  methods: {
    // 获取最新5条评测信息
    async _getCommodityPostList() {
      let param = {
        spuId: this.spuId,
        pageNum: 1,
        pageSize: 1,
        preview: this.$route.query.preview || ''
      }
      let data = await getCommodityPostList(param).catch(e => {})
    if (data?.commentEvaluating?.abtestFlag && data?.commentEvaluating?.evaluatingList?.length) {
        this.postInfo = this.filterEvaData(data.commentEvaluating.evaluatingList).slice(0, 4)//取前4个帖子
        this.evaluateCenterUrl = data?.commentEvaluating?.h5EvaluatingQueryAllUrl
        this.sId = data?.commentEvaluating?.secondaryPageId//专题id
      } else {
        this.postInfo = null
      }
      this.$nextTick(()=>{
        this.checkSwipeWidth()
      })
    },
    /**
     * 滑动开始事件，记录位置
     */
     touchStart() {
      this.translate = this.$refs?.mySwiper?.swiper.getTranslate()
    },
    // 过滤用户昵称和封面图为空的帖子
    filterEvaData(evaluatingData){
      const postInfo = []
      evaluatingData.forEach((vv,vi)=>{
        if(vv.images.length&&vv.author.nickName){
          postInfo.push(vv)
        }
      })
      return postInfo.length > 0 ? postInfo : null//返回的帖子过滤后为空数组时，返回null
    },
    // 跳转测评详情页
    gotoReviewDetail(url,tId) {
      this.clickDataReport(1,tId)
      url = url.length && common.updateURLParameter(url, 'source', 'vivoshoph5')
      setTimeout(() => {
        location.href = url
      })
    },
    gotoReviewCenter(clickPos){
      this.clickDataReport(clickPos)
      this.evaluateCenterUrl = this.evaluateCenterUrl.length && common.updateURLParameter(this.evaluateCenterUrl, 'source', 'vivoshoph5')
      setTimeout(() => {
        location.href = this.evaluateCenterUrl
      });
    },
    touchEnd(){
      const moveDis = -60
      if(!this.showMore)return 
      let move = this.$refs?.mySwiper?.swiper.translate - this.translate
      if (this.$refs?.mySwiper?.swiper.isEnd && move < moveDis) {
        this.gotoReviewCenter(4)
      }
    },
    //计算swiper的宽度是否超出视窗
    checkSwipeWidth() {
      const swiperContainer = document.querySelector('.info');
      const slides = document.querySelectorAll('.info-item.swiper-slide');
      const swiperContainerWidth = swiperContainer.offsetWidth;
      let slideWidth = 0;
      // 计算所有 Slides 的宽度之和
      for (let i = 0; i < slides.length; i++) {
        slideWidth += slides[i].offsetWidth;
      }
      if (slideWidth > swiperContainerWidth) {
        this.showMore = true
      } else {
        this.showMore = false
      }
    },
    clickDataReport(clickPos,tId){
      API.logAll({
      event_id: '081|083|01|077',
      click_Pos: clickPos,//1:帖子2:查看更多3:空白热区4:右滑查看更多
      s_id: this.sId||"",//专题id
      tid: tId||"",//帖子id
      sku_id: this.skuId
    })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
